import {MutableRefObject, useCallback} from "react";
import {useAppSelector} from "../../../redux/hooks";

import {
  getMySongsPageFilterDifficultyMenuTitle
} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.selectors";
import {mySongsPageStore,} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.store";
import {useOnClickOutside} from "../../../components/common/hooks/useOnOutsideClick";
import {useDivRef} from "../../../components/common/hooks/useDivRef";
import {MySongsPageMenuType} from "../../../pages/songs-router/modules/my-songs-page-store/mySongsPage.types";
import {mySongsFiltersStore} from "../../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";

export interface IFilterDifficultyDropdownMenuLogic {
  label: string;
  onClickMenuToggleHandler: () => void;
  isActive?: boolean;
  isAvailable: boolean;
  dropdownFilterMenuRef: MutableRefObject<HTMLDivElement>;
}

const menuName: MySongsPageMenuType = `desktop.levels`;
export const useFilterDifficultyDropdownMenuLogic = (): IFilterDifficultyDropdownMenuLogic => {
  const isAvailable = useAppSelector((): boolean => mySongsFiltersStore.isFilterAvailable("difficulty"));
  const isActive = useAppSelector(() => mySongsPageStore.isMenuActive(menuName));
  const menuLabel = useAppSelector(getMySongsPageFilterDifficultyMenuTitle)

  const onClickOutsideMenuCloseHandler = useCallback(() => {
    if (!isActive) {
      // not active, no reason to close
      return;
    }
    mySongsPageStore.removeActiveMenu(menuName);
  }, [isActive]);

  const dropdownFilterMenuRef = useDivRef();
  useOnClickOutside<HTMLDivElement>(dropdownFilterMenuRef, onClickOutsideMenuCloseHandler);

  return {
    isAvailable,
    isActive,
    onClickMenuToggleHandler: () => mySongsPageStore.toggleSingleActiveMenu(menuName),
    label: menuLabel,
    dropdownFilterMenuRef,
  };
}
